import { BaseShaderMaterial, ResourceContainer, Screen, Time } from '../engine';
import fragment from '../shaders/TexturedGlassFrontShader.frag';
import vertex from '../shaders/TexturedGlassFrontShader.vert';
import DatGui from '../components/DatGui';

import { Vector2 } from 'three';
import { Color } from 'three';
import { FrontSide } from 'three';
import { RepeatWrapping } from 'three';

export default class TexturedGlassFrontMaterial extends BaseShaderMaterial
{
  constructor(rt)
  {
    super(vertex, fragment, {
      resolution: { value :
        new Vector2(Screen.width, Screen.height).multiplyScalar(
          window.devicePixelRatio
        )}
      ,
      difuseTexture: {value: undefined},
    });

    this.tx = [];
    this.tx[0] = ResourceContainer.get_resource('glass_texture_1');
    this.tx[1] = ResourceContainer.get_resource('glass_texture_2');
    this.tx[2] = ResourceContainer.get_resource('glass_texture_3');

    this.transparent = true;

    this.side = FrontSide;
    this.alphaTest = 0.0;

    this.uniforms.difuseTexture.value = this.tx1;

  }

  set opacity(value) 
  {
  }

  get opacity() 
  {
  }
  
  update() 
  {
  }
   
  set(texture_id) 
  {
    if (texture_id < 3 && texture_id >= 0) {

      this.uniforms.difuseTexture.value = this.tx[texture_id];

    }
  }
}
